import {Component, OnInit, Injector} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {CARDINFO, POOLINFO} from '../../../../gen/swagger-api';
import {Observable} from 'rxjs/Observable';
import {HttpOperationsService} from '../../../shared/services/http-operations.service';
import {ModalBaseComponent} from '../modal-base-component';
import {DefaultService} from "../../../../gen/swagger-api/api/default.service";
import {forkJoin} from "rxjs/observable/forkJoin";
import {AlertService} from "../../../shared/services/alert.service";
import {ErrorHandlingService} from "../../../shared/services/error-handling-service";

@Component({
  selector: 'app-load-subscription-modal',
  templateUrl: './load-subscription-modal.component.html',
  styleUrls: ['./load-subscription-modal.component.css']
})
export class LoadSubscriptionModalComponent extends ModalBaseComponent implements OnInit {

  pools: Array<POOLINFO>;
  subscriptions: Array<CARDINFO>;
  step: number = 1;
  enableAfterLoad: boolean;
  selectedPool: POOLINFO;
  nextButtonDisabled: boolean = true;
  public selectedSubscriptionIds: Array<String>;
  paginationIndex: number = 1;
  callback;

  ngOnInit(): void {
    this.loadPools();
    this.selectedSubscriptionIds = [];
    //initialize with all subscriptions selected:
    this.subscriptions.forEach(element => {
      this.selectedSubscriptionIds.push(element.eis.eid);
    });
  }

  constructor(private inject: Injector, private _bsModalRef: BsModalRef,
              private alertService: AlertService,
              private defaultService: DefaultService,
              private errorHandlingService: ErrorHandlingService,
              private httpOperationsService: HttpOperationsService) {
    super(inject);
  }

  //call this whenever you want to close modal
  public closeModal(): void {
    this._bsModalRef.hide();
  }

  public nextStep(): void {
    this.step = 2;
  }


  public confirm(): void {
    let observables: Observable<any>[] = [];

    this.selectedSubscriptionIds.forEach(eis => {
      observables.push(
        this.defaultService.cardsEidProfilesPut(eis.toString(), this.selectedPool.poolId.toString(), this.enableAfterLoad)
          .catch(error => Observable.of(error)
          )
      );
    });
    this.loadNew(observables, "loadSubscription", this.callback);
    this.closeModal();
  }


  private loadNew(observables: Observable<any>[], operationName: string, successCallback?: () => void) {
  console.log('laodNew');
  console.log(observables.length);
    let errors = [];
    const successes = [];
    forkJoin(observables)
      .subscribe(
        error => {
          console.log(error);
          errors = error;
          if (errors.length === 0) {
            this.alertService.successModal(operationName + ' successful');
            if (successCallback && typeof successCallback === 'function') {
              successCallback();
            }
          } else {
            if (error[0] !== null)
            {
              if(error[0]['state'] !== undefined && error[0]['state'] !== null && error[0]['state'] === 'IN_PROCESS'){
                this.alertService.successModal(operationName + ' executed successfully');
              } else{
                this.errorHandlingService.errorHandling(error[0]);
              }
            }
          }
        },
        result => {
          console.log('result:' + JSON.stringify(result));
          if (result.status !== 200) {
            errors.push(result);
          } else {
            successes.push(result);
          }
        }

      );
  }

  public loadPools(): void {
    this.defaultService.poolsGet().subscribe(
      pools => this.pools = pools,
      console.error,
      () => console.log('Pools loaded')
    );
  }

  public onPoolSelectionChange(pool): void {
    this.selectedPool = pool;
    this.nextButtonDisabled = false;
  }


  public onToggleSelectedElement(ev) {
    const id = ev.target.value;
    if (this.selectedSubscriptionIds.includes(id)) {
      let index = this.selectedSubscriptionIds.findIndex(d => d === id); //find index in your array
      this.selectedSubscriptionIds.splice(index, 1);//remove element from array
    } else {
      this.selectedSubscriptionIds.push(id);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/load-subscription/load-subscription-modal.component.ts